import React, { Component } from 'react';
import {
    Button, FormControl, FormGroup, Form,
    PageHeader, ControlLabel
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PhoneInput from 'react-phone-input-2';
import Loader from "react-loader-spinner";
import 'react-phone-input-2/lib/style.css';
import ColumnFormatter from '../../common/ColumnFormatter';
import { AddressComponent } from '../../common/FunctionComponents';

export default class Agency extends Component {
    displayName = 'Agency';

    constructor(props) {

        super(props);

        this.state = {
            isSubmitting: false,
            showSavedMessage: false,
            showErrorMessage: false,
            id: '',
            agencyName: '',
            firstName: '',
            lastName: '',
            streetNumberName: '',
            unitType: '',
            unitNumber: '',
            city: '',
            state: '',
            zipCode: '',
            country: 'USA',
            phoneNumber: '1',
            emailAddress: '',
            features: []
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
    }

    componentDidMount() {
        this.getAgencyInfo();
    }

    handleSubmit(evt) {
        evt.preventDefault();

        this.setState({ isSubmitting: true });

        let url = `api/AgencyService/${localStorage.getItem('agency_key')}/`;
        let options = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: this.state.id,
                name: this.state.agencyName,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                addresses: [
                    {
                        streetNumberName: this.state.streetNumberName,
                        unitType: this.state.unitType,
                        unitNumber: this.state.unitNumber,
                        city: this.state.city,
                        state: this.state.state,
                        zipCode: this.state.zipCode,
                        country: this.state.country
                    }
                ],
                phoneNumber: this.state.phoneNumber,
                emailAddress: this.state.emailAddress
            })
        };

        fetch(url, options)
            .then(response => {
                this.setState({ isSubmitting: false });

                if (response.status === 200)
                    this.setState({ showSavedMessage: true });
                else
                    this.setState({ showSavedMessage: false, showErrorMessage: true });
            });
    }

    handlePhoneNumberChange(value, data, event, formattedValue) {
        this.setState({ phoneNumber: value });
    }

    handleInputChange(evt) {
        evt.preventDefault();
        this.setState({ [evt.target.name]: evt.target.value });
    }

    getAgencyInfo() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${this.props.auth.getAccessToken()}` }
        };

        fetch(`api/AgencyService/${localStorage.getItem('agency_key')}/`, requestOptions)
            .then(response => response.json())
            .then(data => {

                var phone = "1";

                if (data.phoneNumber)
                    phone = data.phoneNumber;

                this.setState({
                    id: data.id,
                    agencyName: data.name,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    streetNumberName: data.addresses[0].streetNumberName,
                    unitType: data.addresses[0].unitType,
                    unitNumber: data.addresses[0].unitNumber,
                    city: data.addresses[0].city,
                    state: data.addresses[0].state,
                    zipCode: data.addresses[0].zipCode,
                    country: !!data.addresses[0].country ? data.addresses[0].country : 'USA',
                    phoneNumber: phone,
                    emailAddress: data.emailAddress,
                    features: data.features
                })
            });
    }

    render() {
        return (
            <div>
                <PageHeader>Agency Information</PageHeader>

                <div className="flex-container">
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <Form onSubmit={this.handleSubmit} >
                            <FormGroup>

                                <ControlLabel>Agency Name *</ControlLabel>
                                <FormControl type="text" name="agencyName" id="agencyName"
                                    value={this.state.agencyName}
                                    onChange={this.handleInputChange} />

                            </FormGroup>

                            <h4>Contact Information</h4>
                            <div className="rowC">
                                <div>
                                    <ControlLabel>First Name *</ControlLabel>
                                    <FormControl type="text" name="firstName" id="firstName"
                                        value={this.state.firstName}
                                        onChange={this.handleInputChange} />
                                </div>
                                <div>
                                    <ControlLabel>Last Name *</ControlLabel>
                                    <FormControl type="text" name="lastName" id="lastName"
                                        value={this.state.lastName}
                                        onChange={this.handleInputChange} />
                                </div>
                            </div>

                            <FormGroup style={{ marginBottom: 20 }}>

                                <ControlLabel>Email *</ControlLabel>
                                <FormControl type="text" name="emailAddress" id="emailAddress"
                                    value={this.state.emailAddress}
                                    onChange={this.handleInputChange} />

                                <ControlLabel>Phone Number *</ControlLabel>
                                <PhoneInput type="text" style={{ zIndex: 2 }}
                                    disableDropdown={true}
                                    country={'us'}
                                    onlyCountries={['us']}
                                    name="phoneNumber"

                                    value={this.state.phoneNumber}
                                    onChange={this.handlePhoneNumberChange} />
                            </FormGroup>

                            <h4>Address</h4>
                            <AddressComponent
                                streetNumberName={this.state.streetNumberName}
                                unitType={this.state.unitType}
                                unitNumber={this.state.unitNumber}
                                city={this.state.city}
                                state={this.state.state}
                                zipCode={this.state.zipCode}
                                country={this.state.country}
                                postalCode={this.state.postalCode}
                                province={this.state.province}

                                handleInputChange={this.handleInputChange}
                            />


                            <Button type="submit" bsStyle="success">Submit</Button>
                            {
                                this.state.isSubmitting &&
                                <Loader type="ThreeDots"
                                    color="#2AABD2"
                                    height={30}
                                    width={30}
                                />
                            }
                            {
                                this.state.showSavedMessage &&
                                <div>Changes have been saved</div>
                            }
                            {
                                this.showErrorMessage &&
                                <div>There was an internal error while updating </div>
                            }
                        </Form>
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <h2>Features</h2>
                        <BootstrapTable data={this.state.features} bordered={true} striped hover>

                            <TableHeaderColumn dataField='featureId' hidden dataSort
                                isKey={true}>Id</TableHeaderColumn>

                            <TableHeaderColumn width='10%' dataField='isActive'
                                dataFormat={ColumnFormatter.asCheckBox}> Active </TableHeaderColumn>

                            <TableHeaderColumn width='30%' dataField='featureName'>
                                Feature Name </TableHeaderColumn>

                            <TableHeaderColumn width='60%' dataField='description'>
                                Description </TableHeaderColumn>

                        </BootstrapTable>

                    </div>
                </div>


            </div>
        );
    }

}






// WEBPACK FOOTER //
// ./src/components/Agency/Agency.js